<template>
  <div>
    <h3>Downloading compliance document, please wait. This process may take a few minutes...</h3>
  </div>
</template>

<script>
import {generateAndDownloadComplianceDocument} from '../utility/campaign/compliance/generateAndDownloadComplianceDocument';

export default {
  name: 'compliance-doc-page',
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async waitAndDownloadComplianceDocument() {
      try {
        await generateAndDownloadComplianceDocument(this.campaignId, true);
      } catch (error) {
        this.showErrorMessage(error.message);
      }
    },
    showErrorMessage(text) {
      $.notify(text, {autoHide: false, position: 'left middle'});
    },
  },
  mounted() {
    this.waitAndDownloadComplianceDocument();
  },
};
</script>
